/**
 * Нижняя модалка (sheet) с плавным появлением и скрытием.
 * open — показывать; onClose — при закрытии; title — заголовок; children — контент (modalBody).
 */
import { useEffect, useState } from "react";

const SHEET_DURATION_MS = 420;

export function BottomSheetModal({ open, onClose, title, children }) {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setVisible(false);
      const id = setTimeout(() => setVisible(true), 20);
      return () => clearTimeout(id);
    } else {
      setVisible(false);
      const t = setTimeout(() => setMounted(false), SHEET_DURATION_MS);
      return () => clearTimeout(t);
    }
  }, [open]);

  if (!mounted) return null;

  return (
    <div
      className={`modal ${visible ? "" : "hidden"}`}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="modalBackdrop" onClick={onClose} />
      <div className="modalSheet">
        <div className="modalHeader">
          <div className="modalTitle">{title}</div>
          <button
            type="button"
            className="crmIconBtn"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        <div className="modalBody">{children}</div>
      </div>
    </div>
  );
}
